<script setup lang="ts">
import type { FormkitCommonProps } from "@/components/ui/input/formkit/formkit.types";
import type { ISubscriberPowerType } from "@/types/backoffice/dto/reference/ref-subscriber-power-type.ts";
import type { FormKitFrameworkContext } from "@formkit/core";
import type { PropType } from "vue";

import { DATA_TEST_IDS } from "@/constants/data-test-ids";
import { useFormkitComputedValue } from "@/hooks/common/use-formkit";
import { getAllSubscriberPowerTypes } from "@/types/backoffice/dto/reference/ref-subscriber-power-type.ts";

/**
 * @deprecated Use non-formkit-specific SubscriberPowerTypeSelect instead or its wrapped version SubscriberPowerTypeDropdownInput
 */
import Dropdown from "primevue/dropdown";

export type ISubscriberPowerTypeDropdownProps = FormkitCommonProps;

const props = defineProps({
  context: {
    type: Object as PropType<FormKitFrameworkContext & ISubscriberPowerTypeDropdownProps>,
  },
});

const value = useFormkitComputedValue<ISubscriberPowerType>(props.context);
</script>

<template>
  <Dropdown
    v-model="value"
    :options="getAllSubscriberPowerTypes()"
    :name="props.context?.name"
    data-key="id"
    :disabled="props.context?.disabled"
    option-label="description"
    :placeholder="props.context?.placeholder"
    class="w-full"
    :data-test-id="DATA_TEST_IDS.components.subscriberPowerTypeDropdown.dropdown()"
    v-bind="$attrs"
  />
</template>

<style scoped></style>
